export default {
    dialogTitleAriaLabel: (title) => `${title} (dialog)`,
    closeDialog: (title) => `Lukk dialog (${title})`
};
//# sourceMappingURL=TEXT.js.map